// src/js/modules/currency.js
function getActiveCurrencyRule() {
  if (typeof window === "undefined") return null;
  return window.__currencyRule || null;
}
function hasCurrencyConversion() {
  return Boolean(getActiveCurrencyRule());
}
function convertMoneyElements() {
  if (typeof window === "undefined" || !window.__currencyConversionRun) return;
  if (!hasCurrencyConversion()) return;
  window.__currencyConversionRun();
}

// src/js/app.js
function initApp() {
  convertMoneyElements();
}

// src/js/index.js
(function init() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initApp);
  } else {
    initApp();
  }
})();
